<template>
  <div id="congrats-candidate">
    <div class="sketch-border create-profile-step-container has-text-centered">
      <div>
        <h3 class="title is-3 has-text-centered">
          You did it!
        </h3>
        <p class="has-text-centered subtitle">
          Top companies are on their way.
        </p>
        <p class="cta has-text-weight-bold">
          <span class="is-size-5">View your
            <i>Confidential Employment Profile</i>
          </span>
        </p>
        <button
          class="button is-rounded is-primary has-text-centered has-text-weight-bold"
          @click="handleClickGoToProfile()"
        >
          Let's go!
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CongratsCandidate',
  data () {
    return {
      isLoading: false
    };
  },
  computed: {
    welcomeMessageData () {
      return {
        recipient: {
          type: this.userAccount.user_type,
          id: this.userAccount._id,
          user_name: this.userName
        }
      };
    },
    userName () {
      return this.userAccount.user_type === 'company'
        ? this.userAccount.company
        : this.userAccount.username;
    },
    userAccount () {
      return this.$store.state.user.account;
    }
  },
  methods: {
    handleClickGoToProfile () {
      this.sendWelcomeMessage();
      this.$store.commit('TOGGLE_WELCOME_TOOLTIP', true);
    },
    sendWelcomeMessage () {
      this.isLoading = true;

      this.$store.dispatch('updateProfileCreationStep', 9)
        .then(() => this.$store.dispatch('editCandidateProfile', this.$store.getters.getUserProfile))
        .then(response => {
          if (response.data.status !== 'saved') {
            this.isLoading = false;
            this.$toasted.show('Oops, something went wrong!');
          } else {
            this.$store.commit(
              'UPDATE_CANDIDATE_PROFILE',
              response.data.data.profile
            );
            this.$socket.emit('send_welcome_message', this.welcomeMessageData);
            this.$router.push('/dashboard');
          }
        })
        .catch(error => {
          console.log(error);
          this.isLoading = false;
          this.$toasted.show('Oops, something went wrong!');
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.cta {
  margin-bottom: 0.5rem;
}
</style>
